import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const FolderStateForm_UpdateFolderState_Mutation = graphql(`
  mutation FolderStateForm_UpdateFolderState(
    $actionId: Id!
    $actionPayload: FolderUpdateStateActionPayloadInput
    $folderId: Id!
    $versionData: VersionDataInput
  ) {
    updateFolderState(
      actionId: $actionId
      actionPayload: $actionPayload
      folderId: $folderId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type FolderStateForm_UpdateFolderState_Result = ResultOf<
  typeof FolderStateForm_UpdateFolderState_Mutation
>;

export const useUpdateFolderStateMutation = () =>
  useGraphQLMutation(FolderStateForm_UpdateFolderState_Mutation);
